module.exports = __webpack_public_path__ + "static/media/loginLogo.19fa7315.png";